import React from "react";

export default function BigBoard() {
  return <div>I am the big board!</div>;
}
